/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { VApplication } from "../../../application";
  import { LoggerModule } from "@vlinder-web/logger-module-react";
import { UPDATE_COSTUME_TYPE } from "../graphql";
  
  const log: any = LoggerModule?.getInstance();
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  export interface CostumeInventoryProps {
    _default: number;
    specialReserve: number;
    sectionSpecific: number;
  }
  export interface ICostumeInventoryMethods extends IPluginMethodMap {
    updateCostumeInventory(args: CostumeInventoryProps): Promise<any>;
  }
  
  export class CostumeInventoryService implements IAgentPlugin {
    readonly methods: ICostumeInventoryMethods;
  
    constructor() {
      this.methods = {
        updateCostumeInventory: this.updateCostumeInventory.bind(this),
      };
    }
  
    async updateCostumeInventory(args: CostumeInventoryProps) {
      log.blue(`CostumeInventory server component:`, args);
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
      try {
        if (client) {
          log.blue(`inviteUser server component222:`, args);
        const res = await client.mutate({
          mutation: UPDATE_COSTUME_TYPE,
          variables: {
           
              ...args,
            
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          return {
            ...res?.data?.updateCostumeType,
          };
        }
        }
      } catch (err: any) {
        let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
      }
    }
  }